"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateUpdate = exports.TemplateQuery = exports.Template = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Template = typebox_1.Type.Object({
    name: typebox_1.Type.String(),
    schema: typebox_1.Type.Unknown(),
    bodyTemplate: typebox_1.Type.String(),
    titleTemplate: typebox_1.Type.String(),
});
exports.TemplateQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
});
exports.TemplateUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.Template, ['name']));
//# sourceMappingURL=template.js.map